/**
 * Pure resolver for the canvas Edit button.
 *
 * Maps the current selection + plugin metadata to one of:
 *   - { kind: "html" }                    — open HtmlEditModal
 *   - { kind: "text" }                    — toggle CKEditor for the box
 *   - { kind: "file", accept: "image/*" } — open file modal
 *   - { kind: "config" }                  — open the plugin's config modal
 *   - { kind: "none", disabledReason }    — button stays disabled
 *
 * Resolution order matches the spec § "Resolution rules". HtmlContent is
 * matched by pluginId and trumps every other rule.
 */

export function resolveEditAction({
  boxSelected,
  boxSelectedAll,
  box,
  pluginToolbar,
  pluginConfig,
} = {}) {
  if (!boxSelected || boxSelected === -1) {
    return { kind: "none", disabledReason: "no_selection" };
  }

  if (Array.isArray(boxSelectedAll) && boxSelectedAll.length > 1) {
    return { kind: "none", disabledReason: "multi_selection" };
  }

  if (!box || !pluginToolbar) {
    return { kind: "none", disabledReason: "no_selection" };
  }

  if (pluginToolbar.pluginId === "sortable_container") {
    return { kind: "none", disabledReason: "container_selected" };
  }

  if (pluginToolbar.pluginId === "HtmlContent") {
    return { kind: "html" };
  }

  const cfg = pluginConfig || {};

  if (cfg.needsTextEdition === true) {
    return { kind: "text" };
  }

  const fileSrc = Array.isArray(cfg.searchIcon)
    ? cfg.searchIcon
    : Array.isArray(cfg.createFromLibrary)
      ? cfg.createFromLibrary
      : null;
  if (fileSrc && fileSrc.length > 0 && typeof fileSrc[0] === "string" && fileSrc[0].length > 0) {
    return { kind: "file", accept: fileSrc[0] };
  }

  if (cfg.needsConfigModal === true) {
    return { kind: "config" };
  }

  return { kind: "none", disabledReason: "unsupported_plugin" };
}

export default resolveEditAction;
